<template>
  <div v-click-outside="closeDatePicker" class="main-search-holder" @click.prevent.stop="">
    <div ref="tttDatePickerInput" :class="inputClasses" @click="toggleDatePicker">
      <div class="checkIn" :class="{ 'no-translate' : dates && dates.startDate }">
        {{ arrivalDate }}
      </div>
      <span v-if="dates && dates.startDate"> - </span>
      <div class="checkOut no-translate">
        {{ departureDate }}
      </div>
      <Cross v-if="dates && dates.startDate" :width="14" :height="14" class="icon close" alt="clear dates" @click="clearDates" />
      <template v-else>
        <div v-if="pickerOpen" class="icon caret-up" alt="close calendar" />
        <div v-else class="icon caret-down" alt="open calendar" />
      </template>
    </div>

    <div class="date-picker-holder-modal" :style="pickerStylesModal">
      <div ref="pickerHolder" class="date-picker-holder" :style="pickerStyles">
        <TTTDatePicker
          :id="settings.id"
          ref="tttDatePicker"
          v-model="dates"
          :within-modal="withinModal"
          :visible="pickerOpen"
          :double="settings.double"
          :showControls="settings.showControls"
          :showMobileInput="settings.showMobileInput"
          :hideArrowsOnMobile="settings.hideArrowsOnMobile"
          :limitDoubleNav="settings.limitDoubleNav"
          :showKeys="settings.showKeys"
          :bookingInfoText="settings.bookingInfoText"
          :layout="settings.layout"
          :numberOfMonths="settings.numberOfMonths"
          :maxContainerWidth="settings.maxContainerWidth"
          :showButtonSet="settings.showButtonSet"
          :showOnlyClear="settings.showOnlyClear"
          :range="settings.range"
          :dynamic="settings.dynamic"
          :highlightOnMouseover="settings.highlightOnMouseover"
          :allowTooltips="settings.allowTooltips"
          :lazyLoadMonths="settings.lazyLoadMonths"
          :switchWeekdays="settings.switchWeekdays"
          :first-day-of-week="settings.firstDayOfWeek"
          :availableDates="settings.availableDates"
          :availableCheckInDates="settings.availableCheckInDates"
          :availableCheckOutDates="settings.availableCheckOutDates"
          :availableDatesWeekly="settings.availableDatesWeekly"
          :pendingDates="settings.pendingDates"
          :pendingDatesWeekly="settings.pendingDatesWeekly"
          :disabled-dates="settings.disabledDates"
          :disabled-weekly="settings.disabledWeekly"
          :disablePastDates="settings.disablePastDates"
          :no-weekends-days="settings.noWeekendDays"
          :min-date="settings.minDate"
          :max-date="settings.maxDate"
          :minBooking="settings.minBooking"
          :maxBooking="settings.maxBooking"
          :messages="settings.messages"
          :locale="currentLanguage"
          :inline="settings.inline"
          :fixedHeight="settings.fixedHeight"
          :containerWidth="settings.containerWidth"
          :externalOpen="externalOpen"
          @selection="onDatesSelected"
          @close="closeDatePicker"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Bus from '../../events/bus';
import { TEMPLATE_IDS } from '../../constants/templates.js';
import { MESSAGES } from './constants/constants.js';
import TTTDatePicker from './TTTDatePicker';
import Cross from '../icons/Cross.vue';

export default {
  name: 'TTTDatePickerInput',
  components: {
    TTTDatePicker,
    Cross,
  },
  directives: {
    ClickOutside,
  },
  props: {
    instanceName: { type: String, default: '' },
    searchVillaId: { type: Number, default: 2 },
    textArrival: { type: String, default: 'Add dates' },
    textDeparture: { type: String, default: '' },
    pickerPosition: { type: String, default: 'absolute' },
    pickerPosLeft: { type: String, default: '0px' },
    pickerPosTop: { type: String, default: '71px' },
    configDates: { type: Object, default: () => {} },
    configOptions: { type: Object, default: null },
    alwaysOpen: { type: Boolean, default: false },
    externalOpen: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    withinModal: { type: Boolean, default: false },
    disableClickOutside: { type: Boolean, default: false },
  },
  data() {
    return {
      TEMPLATE_IDS,
      pickerOpen: false,
      loaded: false,
      dateFormat: 'DD MMM YYYY',
      pickerLeft: '0px',
      pickerTop: '71px',
      options:
      {
        id: 'TTTDatePicker',
        double: true,
        showControls: true,
        showMobileInput: true, // if true and show controls is on - bottom controls will hide on mobile
        hideArrowsOnMobile: true,
        limitDoubleNav: true,
        showKeys: this.instanceName !== 'nav',
        bookingInfoText: '',
        layout: 'horizontal',
        numberOfMonths: 2,
        maxMonths: 20,
        maxContainerWidth: 1400,
        showButtonSet: true,
        showOnlyClear: false,
        range: true,
        dynamic: true,
        highlightOnMouseover: true,
        allowTooltips: true,
        lazyLoadMonths: true,
        switchWeekdays: true,
        firstDayOfWeek: 1,
        availableDates: [],
        availableCheckInDates: [],
        availableCheckOutDates: [],
        availableDatesWeekly: [0, 1, 2, 3, 4, 5, 6],
        pendingDates: [],
        pendingDatesWeekly: [],
        disabledDates: [],
        disabledWeekly: [],
        disablePastDates: true,
        noWeekendDays: false,
        minDate: null,
        // maxDate: '2023-11-23',
        minBooking: 4,
        maxBooking: 40,
        messages: MESSAGES,
        inline: false,
        fixedHeight: false,
        containerWidth: this.instanceName == 'nav' ? '280px' : '284px',
      },
    };
  },
  computed: {
    // --- GETTERS --- //
    dates: {
      get() {
        return this.instanceName == 'villa' ? this.$store.getters['filterbar/getVillaDates'] : this.$store.getters['filterbar/getDates'];
      },
      set(val) {
        if (this.instanceName == 'villa') {
          this.$store.commit('filterbar/setVillaDates', val);
          // this.$store.commit('filterbar/setDates', val);
        }
        else {
          this.$store.commit('filterbar/setDates', val);
        }
      },
    },
    currentLanguage() {
      return this.$store.getters['common/currentLanguage'];
    },
    getDestinations() {
      return this.$store.getters['results/getDestinations'];
    },
    getSubDestinations() {
      return this.$store.getters['results/getSubDestinations'];
    },
    currentTemplateID() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId : null;
    },
    currentCollectionList() {
      return this.$store.getters['pages/getCollectionData'];
    },
    villa() {
      return this.$store.getters['properties/getCurrentProperty'];
    },
    settings() {
      return this.options;
    },
    arrivalDate() {
      let label = this.textArrival;
      if (this.dates && this.dates.startDate && this.dates.startDate !== 'Invalid date') {
        label = this.dates.startDate.replace(/(?:^|\s|[-"'([{])+\S/g, (c) => c.toUpperCase());
      }
      return label;
    },
    departureDate() {
      let label = this.textDeparture;
      if (this.dates && this.dates.endDate && this.dates.endDate !== 'Invalid date') {
        label = this.dates.endDate.replace(/(?:^|\s|[-"'([{])+\S/g, (c) => c.toUpperCase());
      }
      return label;
    },
    pickerStyles() {
      return {
        position: this.pickerPosition,
        left: this.pickerLeft,
        top: this.pickerTop,
      };
    },
    pickerStylesModal() {
      return {
        left: this.pickerLeft,
        top: this.pickerTop,
      };
    },
    inputClasses() {
      return {
        'picker-input': !this.noBorder,
        'picker-input-noborder': this.noBorder,
        focus: this.pickerOpen,
      };
    },
    urlHasFilters() {
      return this.$store.getters['filterbar/urlHasFilters'];
    },
  },
  watch: {
    configOptions: {
      handler(n, o) {
        if (n) {
          this.options = n;
        }
      },
      immediate: true,
      deep: true,
    },
    // getDestinations: {
    //  handler(n, o) {
    //    this.updateBookingConfig();
    //  },
    //  immediate: true,
    //  deep: true,
    // },
    // getSubDestinations: {
    //  handler(n, o) {
    //    this.updateBookingConfig();
    //  },
    //  immediate: true,
    //  deep: true,
    // },
    configDates: {
      handler(n, o) {
        // this.updateBookingConfig();
        // console.log('>>>>>>>>>>configDates updated ', n);

        if (n && n.bookedDates) {
          const bookedDates = this.configDates.bookedDates;
          const contactUsDates = this.configDates.contactUsDates.map((date) => moment(date.date).format('YYYY-MM-DD'));
          const availableDates = this.configDates.bookableDates.map((date) => moment(date.date).format('YYYY-MM-DD'));

          const validAvailablDates = [];
          const invalidAvailableDates = [];

          for (let i = 0; i < availableDates.length; i++) {
            const d = availableDates[i];
            const before = moment(d).subtract(1, 'day');
            const after = moment(d).add(1, 'day');
            const weekBefore = moment(d).subtract(1, 'week');
            const weekAfter = moment(d).add(1, 'week');

            const dayBeforeValid = before.isSame(moment(availableDates[i - 1]));
            const dayAfterValid = after.isSame(moment(availableDates[i + 1]));
            const weekBeforeValid = availableDates.includes(weekBefore.format('YYYY-MM-DD'));
            const weekAfterValid = availableDates.includes(weekAfter.format('YYYY-MM-DD'));

            if (dayBeforeValid || dayAfterValid || weekBeforeValid || weekAfterValid) {
              validAvailablDates.push(d);
            }
            else
            {
              invalidAvailableDates.push(d);
            }
          }
          const pendingDates = contactUsDates.concat(invalidAvailableDates);

          this.options.availableDates = validAvailablDates;
          this.options.pendingDates = pendingDates;
          this.options.disabledDates = bookedDates;
          this.options.availableCheckInDates = this.configDates.bookableDates.filter((d) => d.allowCheckIn).map((date) => moment(date.date).format('YYYY-MM-DD'));
          this.options.availableCheckOutDates = this.configDates.bookableDates.filter((d) => d.allowCheckOut).map((date) => moment(date.date).format('YYYY-MM-DD'));

          // add the contact us dates that allow check in/out to the availabel check in/out dates
          this.options.availableCheckInDates = this.options.availableCheckInDates.concat(this.configDates.contactUsDates.filter((d) => d.allowCheckIn).map((date) => moment(date.date).format('YYYY-MM-DD')));
          this.options.availableCheckOutDates = this.options.availableCheckOutDates.concat(this.configDates.contactUsDates.filter((d) => d.allowCheckOut).map((date) => moment(date.date).format('YYYY-MM-DD')));

          if (this.isVillaBookingDatesInvalid()) {
            this.clearDates();
            // @TODO 2024-07-16 - Julia: Commenting out the notifyUser that check in and check out date are being reset. This notification is too distracting. We need to find a better way to notify the user / mitigate the issue.
            // this.notifyUser();
          }
        }
      },
      immediate: true,
      deep: true,
    },
    alwaysOpen: {
      handler(val) {
        this.pickerOpen = val;
      },
      immediate: false,
      deep: true,
    },
    pickerOpen(val) {
      if (!val && this.dates && this.dates.startDate && !this.dates.endDate) {
        this.clearDates();
      }
    },
  },
  mounted() {
    Bus.$on('clearDates', this.clearDates);
    Bus.$on('closeDatePicker', this.closeDatePicker);
    Bus.$on('closeSearchVillaTabs', this.closeTab);

    this.pickerLeft = this.pickerPosLeft;
    this.pickerTop = this.pickerPosTop;
    this.pickerOpen = this.alwaysOpen;

    this.restoreDates();

    window.addEventListener('resize', this.onScreenResize);
    this.onScreenResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onScreenResize);
    Bus.$off('clearDates', this.clearDates);
    Bus.$off('closeDatePicker', this.closeDatePicker);
    Bus.$off('closeSearchVillaTabs', this.closeTab);
  },
  methods: {
    isVillaBookingDatesInvalid() {
      if (this.dates && this.dates.start && this.dates.end) {
        const start = moment(this.dates.start);
        const end = moment(this.dates.end);
        const availableDates = this.options.availableDates.map((date) => moment((date)).format('YYYY-MM-DD'));
        const availableCheckInDates = this.options.availableCheckInDates.map((date) => moment((date)).format('YYYY-MM-DD'));
        const availableCheckOutDates = this.options.availableCheckOutDates.map((date) => moment((date)).format('YYYY-MM-DD'));

        const disabled = this.options.disabledDates.map((date) => moment((date)).format('YYYY-MM-DD'));
        const pending = this.options.pendingDates.map((date) => moment((date)).format('YYYY-MM-DD'));

        const isStartDateValid = this.isDayAvailableWeekly(start) || availableCheckInDates.includes(start.format('YYYY-MM-DD'));
        const isEndDateValid = this.isDayAvailableWeekly(end) || availableCheckOutDates.includes(end.format('YYYY-MM-DD'));
        const selectedRange = moment.range(start, end);
        const datesRangeArray = Array.from(selectedRange.by('day'));
        const datesNotValid = datesRangeArray.filter((day) => disabled.includes(day.format('YYYY-MM-DD')));
        const datesPending = datesRangeArray.filter((day) => pending.includes(day.format('YYYY-MM-DD')));
        // const datesValid = datesRangeArray.filter((day) => availableDates.includes(day.format('YYYY-MM-DD')));

        this.dates.pending = datesPending.length > 0;

        return (!isStartDateValid || !isEndDateValid || datesNotValid.length > 0);
      }
      return false;
    },
    isDayAvailableWeekly(day) {
      const dayConst = moment(day).day();
      return this.options.availableDatesWeekly.includes(dayConst);
    },
    notifyUser() {
      window.Notification.info({
        customClass: 'custom-notification',
        title: 'Check-in / Check-out dates have been reset. Please select a valid range for this villa.',
        position: 'bottom-right',
        duration: 5000,
        iconClass: 'custom-info-icon',
      });
    },
    onScreenResize() {
      const screenWidth = document.documentElement.clientWidth;

      if (this.instanceName === 'home') {
        if (screenWidth >= 1200) {
          this.pickerLeft = '0px';
          this.pickerTop = '71px';
        }
        // else if (screenWidth >= 768 && screenWidth < 1200) {
        //  this.pickerLeft = '-160px';
        //  this.pickerTop = '115px';
        // }
        else if (screenWidth < 768) {
          this.pickerLeft = '-190px';
          this.pickerTop = '71px';
        }
      }

      if (this.currentTemplateID == TEMPLATE_IDS.VILLA && this.instanceName === 'villa') {
        const innerHeight = window.innerHeight;

        // if (screenWidth >= 1650) {
        //  this.pickerLeft = '-150px';
        //  this.pickerTop = '62px';
        // }
        // else if (screenWidth > 768 && screenWidth < 1650) {
        if (screenWidth > 768) {
          const i = this.$refs.tttDatePickerInput ? this.$refs.tttDatePickerInput.getBoundingClientRect().width : '402';
          const w = this.$refs.tttDatePicker ? this.$refs.tttDatePicker.getWidth.width.replace('px', '') : '628';
          // const x = Math.round((parseInt(w) / 2) - 60);
          const x = w - i;
          this.pickerLeft = `${-x}px`;
          this.pickerTop = '62px';
        }
        else if (screenWidth <= 768) {
          const w = this.$refs.tttDatePicker ? this.$refs.tttDatePicker.getWidth.width : '628';
          const x = Math.round((screenWidth / 2) - (parseInt(w) / 2));
          this.pickerLeft = `${x}px`;
          this.pickerTop = '62px';
        }

        if (innerHeight <= 630) {
          this.pickerTop = '36px';
        }
      }

      if (this.instanceName === 'nav') {
        if (screenWidth >= 1330) {
          this.pickerLeft = '0px';
          this.pickerTop = '71px';
        }
        else if (screenWidth > 1200 && screenWidth < 1330) {
          this.pickerLeft = '0px';
          this.pickerTop = '71px';
        }
        else if (screenWidth <= 1200) {
          this.pickerLeft = '0px';
          this.pickerTop = '71px';
        }
      }
    },
    // updateBookingConfig() {
    //  const des = !!this.configDates && !!this.configDates.regionId
    //    ? this.configDates.regionId
    //    : this.getDestinations.length === 1
    //      ? this.getDestinations[0].id
    //      : null;

    //  const sub = this.currentTemplateID == TEMPLATE_IDS.RESULTS
    //    ? this.getSubDestinations.length === 1
    //      ? this.getSubDestinations[0].id
    //      : null
    //    : this.currentTemplateID == TEMPLATE_IDS.VILLA && !!this.villa
    //      ? this.villa.subRegionid
    //      : null;

    //  // console.log('DES', des);
    //  // console.log('SUB', sub);
    //  // console.log('this.villa', this.villa);
    //  // console.log('this.getSubDestinations', this.getSubDestinations);

    //  // 1 - Sicily
    //  // 4 - Puglia
    //  // 8 - Cosica
    //  // 9 - Minor Italian Island
    //  // 5 - greek islands
    //  // 10 - Mallorca
    //  // 11 - Aegina
    //  // 12 - Alonissos
    //  // 13 - Antiparos
    //  // 14 - Antipaxos
    //  // 15 - Athens_Riviera
    //  // 16 - Corfu
    //  // 17 - Evia
    //  // 18 - Hydra
    //  // 19 - Kastos
    //  // 20 - Kea
    //  // 21 - Kefalonia
    //  // 22 - Lefkada
    //  // 23 - Meganissi
    //  // 24 - Mykonos
    //  // 25 - Paros
    //  // 26 - Patmos
    //  // 27 - Paxos
    //  // 28 - Porto_Heli
    //  // 29 - Serifos
    //  // 30 - Skiathos
    //  // 31 - Skopelos
    //  // 32 - Spetses
    //  // 33 - Syros
    //  // 34 - Tinos
    //  // 35 - Zakynthos

    //  // SAT -  SAT
    //  // 11 Aegina
    //  // 13 Antiparos
    //  // 15 Athens Riviera
    //  // 16 Corfu
    //  // 17 Evia
    //  // 18 Hydra
    //  // 20 Kea
    //  // 21 Kefalonia
    //  // 24 Mykonos
    //  // 25 Paros
    //  // 26 Patmos
    //  // 27 Paxos
    //  // 28 Porto Heli
    //  // 29 Serifos
    //  // 31 Antipaxos
    //  // 32 Spetses
    //  // 33 Syros
    //  // 34 Tinos
    //  // 35 Zakynthos

    //  // FRI - FRI
    //  // 12    Alonissos
    //  // 30    Skiathos
    //  // 31    Skopelos

    //  // SUN - SUN
    //  // 19    Kastos
    //  // 22    Lefkada
    //  // 23    Meganissi

    //  // TODO: The below logic will be set per villa and will only apply on the villa widget
    //  // TODO: Also set the minBooking based on villa settings

    //  if (des == 1) {
    //    this.options.bookingInfoText = "Sicily villas generally rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //    this.options.availableDatesWeekly = [6];
    //    this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Saturday to Saturday';
    //  }
    //  else if (des == 4) {
    //    this.options.bookingInfoText = "Puglia villas generally rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //    this.options.availableDatesWeekly = [6];
    //    this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Saturday to Saturday';
    //  }
    //  else if (des == 9) {
    //    this.options.bookingInfoText = "Tuscan Islands villas generally rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //    this.options.availableDatesWeekly = [6];
    //    this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Saturday to Saturday';
    //  }
    //  // else if (des == 10) {
    //  //   this.options.bookingInfoText = 'Mallorca villas generally rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong>.';
    //  //   this.options.availableDatesWeekly = [6];
    //  //   this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Saturday to Saturday';
    //  // }
    //  else if (des == 8) {
    //    this.options.bookingInfoText = "Corsica villas generally rent from <strong>SUNDAY</strong> to <strong>SUNDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //    this.options.availableDatesWeekly = [0];
    //    this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Sunday to Sunday';
    //  }
    //  else if (des >= 11) {
    //    // des greece IDs are all 11 or higher now
    //    this.options.bookingInfoText = "All our Greece villas rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong> except for Lefkada, Meganissi and Kastos which rent <strong>SUNDAY</strong> to <strong>SUNDAY</strong> and Skopelos, Alonissos and Skiathos which rent <strong>FRIDAY</strong> to <strong>FRIDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //    this.options.availableDatesWeekly = [5, 6, 0];
    //    this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be on Friday, Saturday or Sunday';

    //    if (this.currentTemplateID == TEMPLATE_IDS.RESULTS || this.currentTemplateID == TEMPLATE_IDS.VILLA) {
    //      let subRegionName = '';
    //      if (this.currentTemplateID == TEMPLATE_IDS.VILLA && this.villa) {
    //        subRegionName = this.villa.location.includes(',') ? this.villa.location.split(', ')[1] : this.villa.location;
    //      }
    //      else if (this.currentTemplateID == TEMPLATE_IDS.RESULTS && this.getSubDestinations[0]) {
    //        subRegionName = this.getSubDestinations[0].name;
    //      }

    //      const sundayIds = [19, 22, 23];
    //      const fridayIds = [12, 30, 31];
    //      const saturdayIds = [11, 13, 15, 16, 17, 18, 20, 21, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35];

    //      if (sundayIds.includes(des)) {
    //        this.options.bookingInfoText = `${subRegionName} villas generally rent from <strong>SUNDAY</strong> to <strong>SUNDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.`;
    //        this.options.availableDatesWeekly = [0];
    //        this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Sunday to Sunday';
    //      }
    //      else if (fridayIds.includes(des)) {
    //        this.options.bookingInfoText = `${subRegionName} villas generally rent from <strong>FRIDAY</strong> to <strong>FRIDAY</strong>.  If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.`;
    //        this.options.availableDatesWeekly = [5];
    //        this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Friday to Friday';
    //      }
    //      else if (saturdayIds.includes(des)) {
    //        if (des === 27) {
    //          subRegionName = this.currentTemplateID == TEMPLATE_IDS.VILLA ? 'Paxos' : 'Paxos and Antipaxos';
    //        }
    //        this.options.bookingInfoText = `${subRegionName} villas generally rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong>.  If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.`;
    //        this.options.availableDatesWeekly = [6];
    //        this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be from Saturday to Saturday';
    //      }
    //      else {
    //        this.options.bookingInfoText = "All our Greece villas rent from <strong>SATURDAY</strong> to <strong>SATURDAY</strong> except for Lefkada, Meganissi and Kastos which rent <strong>SUNDAY</strong> to <strong>SUNDAY</strong> and Skopelos, Alonissos and Skiathos which rent <strong>FRIDAY</strong> to <strong>FRIDAY</strong>. If this doesn't fit with your plans, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //        this.options.availableDatesWeekly = [5, 6, 0];
    //        this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be on Friday, Saturday or Sunday';
    //      }
    //    }
    //  }
    //  else {
    //    this.options.bookingInfoText = "N.B. Most villas have a minimum stay of 7 nights. Start days vary according to the destination. If you can't find your dream villa for your perfect dates, contact our Villa Specialists - they'll do everything possible to find a flexible solution for you.";
    //    this.options.availableDatesWeekly = [0, 1, 2, 3, 4, 5, 6];
    //    this.options.messages.NON_BOOKABLE = 'Check in / Check out needs to be on Friday, Saturday or Sunday';
    //  }
    // },
    toggleDatePicker() {
      if (!this.alwaysOpen) {
        this.pickerOpen = !this.pickerOpen;
        this.pickerOpen ? Bus.$emit('closeSearchVillaTabs', this.searchVillaId) : null;
        this.$emit('visible', this.pickerOpen);
      }
    },
    closeTab(id) {
      if (id != this.searchVillaId) {
        this.closeDatePicker();
      }
    },
    closeDatePicker() {
      if (this.pickerOpen && this.disableClickOutside) {
        console.log('closeDatePicker');
        this.$emit('close');
      }

      if (!this.externalOpen && !this.alwaysOpen) {
        this.pickerOpen = false;
        this.$emit('visible', this.pickerOpen);
        this.instanceName === 'villa' ? document.getElementById('villaWidgetComponent').focus() : null;
      }
    },
    formatDate(date) {
      return moment(date).format(this.dateFormat);
    },
    onDatesSelected(val) {
      if (val && val.start) {
        window.$cookies.set('startdate', val.start);
        window.$cookies.set('enddate', val.end);
      }
      else if (!val) {
        window.$cookies.set('startdate', '');
        window.$cookies.set('enddate', '');
      }
      this.$emit('selection', val);
    },
    clearDates() {
      this.dates = null;
      this.$emit('selection', this.dates);
      this.$router.replace({ query: { ...this.$route.query, to: undefined, from: undefined } });
      window.$cookies.set('startdate', '');
      window.$cookies.set('enddate', '');
    },
    restoreDates() {
      const from = this.$route.query.from;
      const to = this.$route.query.to;
      const fromCookie = window.$cookies.get('startdate');
      const toCookie = window.$cookies.get('enddate');

      if (!!from && !!to && moment(from)._isValid && moment(to)._isValid) {
        this.dates = {
          start: moment(from).format('YYYY-MM-DD'), end: moment(to).format('YYYY-MM-DD'), startDate: this.formatDate(from), endDate: this.formatDate(to),
        };
      } else if (!this.urlHasFilters && !this.currentCollectionList && !!fromCookie && !!toCookie) {
        this.dates = {
          start: fromCookie, end: toCookie, startDate: this.formatDate(fromCookie), endDate: this.formatDate(toCookie),
        };
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/settings/config.scss";
$solitude: #eaeff4;

.main-search-holder{
  position:relative;
}

.date-picker-holder{
  position: absolute;
  overflow: visible;
}

  .picker-input-noborder {
    position: relative;
    height: 70px;
    background-color: $limeStone;
    padding: 0 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    color: $darkBlack;

    &.focus {
      background-color: $stoneCream;
    }

    .mobile-search-villa__container & {
      background-color: $stoneWhite;

      &.focus {
        background-color: $stoneWhite;
      }
    }

    div {
      display: inline-block;
      cursor: pointer;
    }

    .checkIn {
      text-align: left;
    }

    .checkOut {
      text-align: left;
      margin-right: 10px;
    }

    .icon {
      cursor: pointer;

      &.caret-up {
        background-image: url(../../assets/img/src/icons/chevron-up.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
        right: 2px;
        top: 17px;
      }

      &.caret-down {
        background-image: url(../../assets/img/src/icons/chevron-down.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
        right: 2px;
        top: 17px;
      }

      &.close {
        background-size: 13px 13px;
        right: 2px;
        top: 17px;
      }
    }
  }

  .picker-input {
    position: relative;
    border: 1px solid $yellowStone;
    /*border-radius: 8px;*/
    height: 62px;
    background-color: $stoneWhite;
    padding: 0 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    color: $darkBlack;

    &.focus {
      background-color: $stoneCream;
    }

    .mobile-search-villa__container & {
      background-color: $stoneWhite;

      &.focus {
        background-color: $stoneWhite;
      }
    }

    div {
      display: inline-block;
      cursor: pointer;
    }

    .checkIn {
      padding: 0;
      font-size: 16px;
    }

    .checkOut {
      padding: 0;
      font-size: 16px;
    }

    .icon {
      cursor: pointer;

      &.calendar {
        background-image: url(../TTTDatePicker/assets/icons/cal-icon-cal.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
      }

      &.caret-up {
        background-image: url(../../assets/img/src/icons/chevron-up.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
      }

      &.caret-down {
        background-image: url(../../assets/img/src/icons/chevron-down.svg);
        background-size: 13px 13px;
        width: 13px;
        height: 13px;
      }

      &.close {
        background-size: 13px 13px;
      }
    }
  }

</style>
